import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import BottomMenu from './BottomMenu';
  
class ReOrder2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: true,
            ORDER_ADDED: '',
            id: props.match.params.id
        };
    }

    fetchRestaurantMenu(mode,customer,id) {
        var subsciber_id = localStorage.getItem('SUBSCRIBER_ID');
        var that = this;
        fetch('https://m.donedelivery.in/api/reorder_api2.php?mode='+mode+'&order_id='+id+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let ORDER_ADDED = result.ORDER_ADDED;
            if(ORDER_ADDED=='' || ORDER_ADDED==undefined)
                ORDER_ADDED = '';

            let ITEMS = result.ITEMS;
            if(ITEMS!='' && ITEMS!=undefined)
            {
                let cartCIRCLE = localStorage.getItem('cartCIRCLE');
                let circleID = localStorage.getItem('delCIRCLE2');
                if(cartCIRCLE === null || cartCIRCLE==='{}')
                    localStorage.setItem('cartCIRCLE',circleID);
        
                let cartTotalCount = 0;
                let inCart = 'N';
                let addButton = 'Y';
                let cartCount = 0;
        
                var addToObject = function (obj, key, value, index) {
                    // Create a temp object and index variable
                    var temp = {};
                    var i = 0;
                
                    // Loop through the original object
                    for (var prop in obj) {
                        if (obj.hasOwnProperty(prop)) {
                            // If the indexes match, add the new item
                            if (i === index && key && value) {
                                temp[key] = value;
                            }
                            // Add the current item in the loop to the temp obj
                            temp[prop] = obj[prop];
                            // Increase the count
                            i++;
                        }
                    }
                
                    // If no index, add to the end
                    if (!index && key && value) {
                        temp[key] = value;
                    }
                    return temp;
                };
                
                
                ITEMS.map(item=>{

                    let id = item.ID;
                    let unit = item.UNIT;
                    let qty = parseInt(item.CART_QTY);
                    let vendor_id = item.VENDOR_ID;
                    let vendor_name = item.VENDOR_NAME;
                    let vendortype_id = item.VENDORTYPE_ID;

                    let cart = localStorage.getItem('cartData');
                    let cartVendorID = localStorage.getItem('cartVendorID');
                    let cartVendorName = localStorage.getItem('cartVendorName');
                    let cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

                    if (cart === null) {
                        var a = {[id+'~~**~~'+unit]: qty};  
                        localStorage.setItem('cartData',JSON.stringify(a));
                        localStorage.setItem('cartVendorID',vendor_id);
                        localStorage.setItem('cartVendorName',vendor_name);
                        localStorage.setItem('cartVendorTypeID',vendortype_id);
                    }
                    else
                    {
                        let ALLOW_CART = 'Y';
                        if(cartVendorID!=vendor_id)
                        {
                            if(cartVendorTypeID!=vendortype_id)
                                ALLOW_CART = 'N';
                            else
                            {
                                if(cartVendorTypeID=='2' && vendortype_id=='2')
                                    ALLOW_CART = 'N';
                            }
                        }

                        if(ALLOW_CART=='Y')
                        {
                            var cartData = JSON.parse(cart);
                            Object.keys(cartData).forEach(function(key) {
                                let cart_id = key.split('~~**~~');
                                if(cart_id[0]==id && unit==cart_id[1])
                                    delete cartData[key];
                            });
                
                            cartData = addToObject(cartData, [id+'~~**~~'+unit], qty);
                            localStorage.setItem('cartData', JSON.stringify(cartData));
                        }
                    }  
                });
                that.setState({ ORDER_ADDED: 'Y' });
            }
            else
                that.setState({ ORDER_ADDED: 'N' });
        });
    }

    componentDidMount() {
        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        
        this.fetchRestaurantMenu('REORDER',customer,this.state.id);
    }
    
    render() { 

        //console.log(localStorage.getItem('delCity'));
        //console.log(localStorage.getItem('delArea'));
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        if(this.state.ORDER_ADDED=='Y')
        {
            return (<Redirect to='/cart' />)
        }

        if(this.state.ORDER_ADDED=='N')
        {
            return (<Redirect to='/home' />)
        }

        if(localStorage.getItem('delCIRCLE')==null)
        {
	        return (<Redirect to={'/map'}/>)
        }

        return (
            <div>
                {this.state.LOADING && <Loader />}
            </div>
        );
    }
}
      
export default ReOrder2;


// WEBPACK FOOTER //
// ./src/components/ReOrder2.js